export enum InsightsEvents {
  CLICKED_FILTERS = "clickedFilters",
  CLICKED_RESULTS = "clickedObjectIDsAfterSearch",
}
